import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import Home from "./pages/home";
import About from "./pages/about";
import Product from "./pages/product";
import Contact from "./pages/contact";
import PrivacyPolicy from "./pages/policy";
import TermsOfUse from "./pages/terms";
import PhoneNumberScreen from "./pages/phonenumberscreen";
import OTPVerification from "./pages/validateotp";
import Emergencycall from "./pages/emergencycall";
import { store } from "./redux/store";
import AIChatScreen from "./pages/aichatscreen";
import BusinessCard from "./pages/businesscard";
import ScrollToTop from "./components/site/ScrollToTop";

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/product" element={<Product />} />
          <Route path="/lifestyle" element={<Navigate to="/" replace />} />
          <Route path="/lifestyle/:slug" element={<Navigate to="/" replace />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/policy" element={<Navigate to="/privacy" replace />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/about/business_card" element={<BusinessCard />} />
          <Route path="/qrify/:id" element={<PhoneNumberScreen />} />
          <Route path="/otp/:id/:ref_id" element={<OTPVerification />} />
          <Route path="/call/:id" element={<Emergencycall />} />
          <Route path="/emergencycall" element={<Emergencycall />} />
          <Route path="/aichatscreen/:id" element={<AIChatScreen />} />
        </Routes>
      </Router>
    </Provider>
  );
};

export default App;
